import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'pipelines-panel-notes-syndicated',
  imports: [],
  templateUrl: './pipelines-panel-notes-syndicated.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pipelines-panel-notes-syndicated.component.scss','../../pipelines-table.component.scss']
})
export class PipelinesPanelNotesSyndicatedComponent {
  @Input() detail:any;

}
